/**
 * Situação incomum no site ao vivo (DR-33; P-27; léxico §5.4; coordenação de 13/10, Ensaio 0): a vaga do painel na
 * coluna direita sem foco (abaixo de "Últimas atualizações") e na seção "Mais sobre a apuração" do celular
 * (panelsSlot.tsx). Só monta com a camada no snapshot (`files.insights`, sinal `insightsPath`), a partir da abertura
 * das urnas (nada antes das 17h, regra 4) e nunca na TV (DR-33: nem toast, nem overlay, nem modo TV).
 *
 * Chunk `insights` (DE-C20): o painel, os textos de análise e o validador dos insights (validate.insights.ts) ficam
 * fora do JS crítico, pedidos só com a camada ligada. Uma falha do `import()` vai para a boundary `insights`.
 */
import { ErrorBoundary } from '../features/errors/ErrorBoundary';
import { useLayout, usePhase, useRouteState } from '../state/hooks';
import { insightsPath } from '../state/store';
import { lazyChunk, useLazyChunk } from './lazyChunk';

export const insightsChunk = lazyChunk(() => import('./insightsLive'));

function InsightsChunk() {
  const mod = useLazyChunk(insightsChunk, true);
  if (!mod) return null;
  const { LiveInsights } = mod;
  return <LiveInsights />;
}

export function InsightsSlot() {
  const path = insightsPath.value;
  const phase = usePhase();
  const layout = useLayout();
  if (path === null || phase === 'pre_open' || layout.mode === 'tv') return null;
  return (
    <ErrorBoundary name="insights">
      <InsightsChunk />
    </ErrorBoundary>
  );
}

function MunicipalityInsightsChunk({ ibge }: { ibge: string }) {
  const mod = useLazyChunk(insightsChunk, true);
  if (!mod) return null;
  const { MunicipalityInsights } = mod;
  return <MunicipalityInsights ibge={ibge} />;
}

/** O quadro do próprio município no cartão dele (§8.4; DR-33), com as mesmas condições do painel. */
export function MunicipalityInsightsSlot() {
  const path = insightsPath.value;
  const phase = usePhase();
  const layout = useLayout();
  const route = useRouteState();
  const place = route.place;
  if (place.kind !== 'municipality' || path === null || phase === 'pre_open' || layout.mode === 'tv') return null;
  return (
    <ErrorBoundary name="insights">
      <MunicipalityInsightsChunk ibge={place.ibge} />
    </ErrorBoundary>
  );
}
